import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { addRendition } from '@shared/utils/photoRendition';
import { TemplateProps } from '../templates.types';
import { StyledAssetBackground, DetailsContainer } from './Arch2.styles';
import { getThemeInfo } from '@apps/saveTheDate/SaveTheDate.utils';
import useAdjustableImage from '../../../../hooks/useAdjustableImage';

const assetArchUrl = getThemeInfo('arch2')?.assetUrl || '';

export const Arch2: React.FC<TemplateProps> = ({
  imageUrl,
  inviteToFollow,
  formattedDate,
  formattedOwnerName,
  formattedFianceeName,
  formattedLocation,
  isFullNamesFormat,
  isAdjustingPosition,
  ...rest
}) => {
  const { AdjustableImage } = useAdjustableImage({ imageUrl, isAdjustingPosition, ...rest });

  return (
    <>
      <AdjustableImage />
      <StyledAssetBackground
        isAdjustingPosition={!!isAdjustingPosition}
        backgroundImage={addRendition({ url: assetArchUrl, renditionSize: 'medium' })}
      >
        <Flex
          height="100%"
          padding="30px 50px"
          flexDirection="column"
          alignItems="flex-end"
          justifyContent="flex-end"
        >
          <TextV2
            color="white"
            textAlign="right"
            fontSize={14}
            fontFamily="Quicksand"
            fontWeight="bold"
            lineHeight="21px"
            letterSpacing="0.2em"
            textTransform="uppercase"
          >
            {formattedOwnerName}
            {formattedFianceeName ? ' & ' : ''}
            {isFullNamesFormat && !!formattedFianceeName && <br />}
            {formattedFianceeName || ''}
          </TextV2>
          {(formattedDate || formattedLocation || inviteToFollow) && (
            <DetailsContainer
              flexDirection="column"
              alignItems="flex-end"
            >
              {formattedDate ? (
                <TextV2
                  color="white"
                  textAlign="right"
                  fontSize={12}
                  fontFamily="Quicksand"
                  fontWeight={400}
                  lineHeight="15px"
                  letterSpacing="0.2em"
                  textTransform="uppercase"
                >
                  {formattedDate}
                </TextV2>
              ) : null}
              {formattedLocation ? (
                <TextV2
                  color="white"
                  textAlign="right"
                  fontSize={12}
                  fontFamily="Quicksand"
                  fontWeight={400}
                  lineHeight="15px"
                  letterSpacing="0.2em"
                  textTransform="uppercase"
                >
                  {formattedLocation}
                </TextV2>
              ) : null}
              {inviteToFollow ? (
                <TextV2
                  color="white"
                  textAlign="right"
                  fontSize={12}
                  fontFamily="Quicksand"
                  fontWeight={400}
                  lineHeight="15px"
                  letterSpacing="0.2em"
                  textTransform="uppercase"
                >
                  {inviteToFollow}
                </TextV2>
              ) : null}
            </DetailsContainer>
          )}
        </Flex>
      </StyledAssetBackground>
    </>
  );
};
